'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMusicalNote = function IoIosMusicalNote(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 8v5.1c0 0.3-0.2 0.5-0.5 0.4l-5.7-1v15c0 2.6 0.1 6.3-4 6.4-3.7 0.2-4.8-1.2-4.8-3.2 0-1.5 0.7-3 4-3.2 1.7-0.1 2.9-0.1 3.5-0.1v-21.3l7 1.5 0.2 0.1c0.1 0 0.2 0 0.3 0.2v0.1z' })
        )
    );
};

exports.default = IoIosMusicalNote;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-musical-note.js
// module id = 2219
// module chunks = 0